import { language, BRAND_NAME } from "@chef/constants";

export const intl = (
  {
    no: {
      GIFTCARD_AMOUNT: "Gavekort sum",
      GIFTCARD_FOR: "Gavekort til",
      SENDER: "Ditt navn",
      YOUR_EMAIL: "Din e-post",
      NEEDS_TO_BE_EMAIL: "Må være e-post",
      REQUIRED_NAME_FIELD: "Skriv inn navnet ditt",
      REQUIRED_EMAIL_FIELD: "Skriv inn din e-post",
      CHECK_WHERE_WE_DELIVER:
        "Sjekk om vi leverer til mottakeren av gavekortet",
      HERE: "her",
      SUM_TO_PAY: "Sum å betale",
      TO_PAYMENT: "Til betaling",
      SOMETHING_WENT_WRONG: "Noe gikk galt, prøv å oppdatere siden",
      I_ACCEPT_CURRENT: "Jeg godtar gjeldende ",
      TERMS_AND_CONDITIONS: "vilkår",
      FOR_PURCHASE_OF_GIFTCARD: " for kjøp av gavekort",
      GIFTCARD_MINIMUM_AMOUNT: ({
        MINIMUM_AMOUNT,
      }: {
        MINIMUM_AMOUNT: number;
      }) => `Gavekortet må være på min. ${MINIMUM_AMOUNT} kr`,
      GIFTCARD_MAXIMUM_AMOUNT: ({
        MAXIMUM_AMOUNT,
      }: {
        MAXIMUM_AMOUNT: number;
      }) => `Gavekortet må være på maks. ${MAXIMUM_AMOUNT} kr`,
      REQUIRED_FIELD: "Påkrevd felt",
      JUST_DIGITS_ALLOWED: "Kan bare inneholde tall",
      CHOOSE_AMOUNT: "Velg beløp",
      YOU_MUST_SELECT_AN_AMOUNT: "Du må velge et beløp",
      YOUR_INFORMATION: "Din informasjon",
      ACCEPT_THE_TERMS: "Godta vilkårene",
      MINIMUM_AMOUNT: "Min. 250 kr",
    },
    se: {
      GIFTCARD_AMOUNT: "Presentkortssumma",
      GIFTCARD_FOR: "Presentkort till",
      SENDER: "Ditt namn",
      YOUR_EMAIL: "Din e-post",
      NEEDS_TO_BE_EMAIL: "Måste vara e-post",
      REQUIRED_NAME_FIELD: "Ange ditt namn",
      REQUIRED_EMAIL_FIELD: "Ange din e-post",
      CHECK_WHERE_WE_DELIVER:
        "Kontrollera om vi levererar till mottagarens adress",
      HERE: "här",
      SUM_TO_PAY: "Summa att betala",
      TO_PAYMENT: "Till betalning",
      SOMETHING_WENT_WRONG: "Något gick fel, försök att uppdatera sidan",
      I_ACCEPT_CURRENT: "Jag accepterar gällande ",
      TERMS_AND_CONDITIONS: "villkor",
      FOR_PURCHASE_OF_GIFTCARD: " vid köp av presentkort",
      GIFTCARD_MINIMUM_AMOUNT: ({
        MINIMUM_AMOUNT,
      }: {
        MINIMUM_AMOUNT: number;
      }) => `Presentkortet måste vara på minst ${MINIMUM_AMOUNT} kr.`,
      GIFTCARD_MAXIMUM_AMOUNT: ({
        MAXIMUM_AMOUNT,
      }: {
        MAXIMUM_AMOUNT: number;
      }) => `Presentkortet får inte överskrida ${MAXIMUM_AMOUNT} kr.`,
      REQUIRED_FIELD: "Obligatoriskt fält",
      JUST_DIGITS_ALLOWED: "Kan bare inneholde tall",
      CHOOSE_AMOUNT: "Välj belopp",
      YOU_MUST_SELECT_AN_AMOUNT: "Du måste välja ett belopp",
      YOUR_INFORMATION: "Dina uppgifter",
      ACCEPT_THE_TERMS: "Godkänn villkoren",
      MINIMUM_AMOUNT: "Min. 250 kr",
    },
    dk: {
      GIFTCARD_AMOUNT: "Beløb",
      GIFTCARD_FOR: "Gavekort til",
      SENDER: "Dit navn",
      YOUR_EMAIL: "Din e-mail",
      NEEDS_TO_BE_EMAIL: "Må være e-mail",
      REQUIRED_NAME_FIELD: "Indtast dit navn",
      REQUIRED_EMAIL_FIELD: "Indtast din e-mailadresse",
      CHECK_WHERE_WE_DELIVER:
        "Tjek, om vi leverer måltidskasser til modtageren af gavekortet",
      HERE: "her",
      SUM_TO_PAY: "Samlet beløb",
      TO_PAYMENT: "Gå videre til betaling",
      SOMETHING_WENT_WRONG: "Der opstod en fejl",
      I_ACCEPT_CURRENT: "Jeg har læst og accepterer RetNemt.dk’s  ",
      TERMS_AND_CONDITIONS: "handelsbetingelser",
      FOR_PURCHASE_OF_GIFTCARD: "",
      GIFTCARD_MINIMUM_AMOUNT: ({
        MINIMUM_AMOUNT,
      }: {
        MINIMUM_AMOUNT: number;
      }) => `Gavekortet skal være på minimum ${MINIMUM_AMOUNT} kr.`,
      GIFTCARD_MAXIMUM_AMOUNT: ({
        MAXIMUM_AMOUNT,
      }: {
        MAXIMUM_AMOUNT: number;
      }) => `Gavekortet må være på maks. ${MAXIMUM_AMOUNT} kr.`,
      REQUIRED_FIELD: "Påkrævet",
      JUST_DIGITS_ALLOWED: "Kan bare inneholde tall",
      CHOOSE_AMOUNT: "Vælg beløb",
      YOU_MUST_SELECT_AN_AMOUNT: "Du må selv vælge beløbet.",
      YOUR_INFORMATION: "Dine oplysninger",
      ACCEPT_THE_TERMS: "Godkend vilkårene",
      MINIMUM_AMOUNT: "Min. 250 kr",
    },
  } as const
)[language];

export const brand = (
  {
    AMK: {
      ADVENT_GIFT_CARD_PDF_ID: "F1229C77-F7BD-4199-B8FC-0BC322014F17",
      GIFT_CARD_PDF_ID: "2996779E-53CA-44B1-AD79-014C011CED60",
      PRESET_AMOUNTS: [
        { amount: "1000", description: "Tilsvarer 3 middager for 4 personer" },
        { amount: "750", description: "Tilsvarer 3 middager for 2 personer" },
        { amount: "3000", description: "Tilsvarer 3-4 leveringer" },
      ],
    },

    GL: {
      ADVENT_GIFT_CARD_PDF_ID: "AF17DEB5-8222-42B7-B00B-D27216AA9E2D",
      GIFT_CARD_PDF_ID: "3E6A35CC-43A3-4E33-B718-AB3177D9D678",
      PRESET_AMOUNTS: [
        { amount: "1000", description: "Tilsvarer 3 middager for 4 personer" },
        { amount: "750", description: "Tilsvarer 3 middager for 2 personer" },
        { amount: "3000", description: "Tilsvarer 3-4 leveringer" },
      ],
    },

    LMK: {
      ADVENT_GIFT_CARD_PDF_ID: "",
      GIFT_CARD_PDF_ID: "9C810195-4D16-4853-8007-08206F288955",
      PRESET_AMOUNTS: [
        { amount: "1000", description: "Motsvarar 3 middagar för 4 personer" },
        { amount: "750", description: "Motsvarar 3 middagar för 2 personer" },
        { amount: "3000", description: "Motsvarar 3-4 leveranser" },
      ],
    },

    RN: {
      ADVENT_GIFT_CARD_PDF_ID: "",
      GIFT_CARD_PDF_ID: "72E0D529-A65E-40A4-B5A3-49234B003C3C",
      PRESET_AMOUNTS: [
        { amount: "1000", description: "Mad til 5 dage" },
        { amount: "750", description: "Prøv en måltidskasse" },
        { amount: "2500", description: "Nok til 3-4 leveringer" },
      ],
    },
  } as const
)[BRAND_NAME];
